import { UserRole } from '../types/shared.types';

export const userRoles = Object.values(UserRole);

export const userRolesWithoutSystem = Object.values(UserRole).filter(
  (role) => role !== UserRole.SYSTEM,
);

export const defaultImage =
  'https://ds4obdd88tc6q.cloudfront.net/45e0f641bffc43ef89d07547fea65fcd_image_1024.png';

export const emolaLogo =
  'https://play-lh.googleusercontent.com/2TGAhJ55tiyhCwW0ZM43deGv4lUTFTBMoq83mnAO6-bU5hi2NPyKX8BN8iKt13irK7Y=w240-h480-rw';

export const colors = {
  primary: '#007AFF',
  green: '#34c759',
  blue: '#007AFF',
  red: '#ff3a30',
  cyan: '#64d3ff',
  gray: '#c7c7cc',
  black: '#000000',
  white: '#ffffff',
  purple: '#5856d6',
  orange: '#ff9500',
};

/**
 * Threshold used to derive the `stale` status for `pending` rows.
 * Hoisted to a constant so backend reports and the Flutter UI stay in sync.
 */
export const WEIGHTED_SALE_STALE_THRESHOLD_MS = 2 * 60 * 60 * 1000; // 2h

/**
 * Currency the PLATFORM itself bills in (pricing plans, invoices, wallet
 * top-ups). Merchant-facing money always uses the merchant's own currency —
 * this constant exists only for platform-billing fallbacks where no
 * agreement/invoice currency is available yet, so expanding beyond the MZN
 * billing rail is a one-place change.
 */
export const PLATFORM_BILLING_CURRENCY = 'MZN';
